import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const ToolCardSkeleton = () => {
    return (
        <Card className="shadow-sm">
            <div className="p-5 space-y-4">
                {/* Header with Icon, Title, Date and ID */}
                <div className="flex items-start justify-between gap-3">
                    <div className="flex items-start gap-3 flex-1 min-w-0">
                        {/* Icon */}
                        <Skeleton className="h-10 w-10 rounded-lg flex-shrink-0" />
                        
                        {/* Title and Date */}
                        <div className="flex-1 space-y-2">
                            <Skeleton className="h-5 w-2/3" />
                            <Skeleton className="h-4 w-1/3" />
                            <Skeleton className="h-4 w-1/2" />
                        </div>
                    </div>

                    {/* ID Skeleton on Right */}
                    <Skeleton className="h-8 w-[140px] rounded-md" />
                </div>

                {/* Grid Skeleton */}
                <div className="rounded-lg border border-border overflow-hidden bg-muted/30">
                    <div className="grid grid-cols-3 divide-x divide-border">
                        {/* Row 1 */}
                        {[...Array(3)].map((_, i) => (
                            <div key={`row1-${i}`} className="h-11 flex flex-col items-center justify-center gap-1 px-2.5 py-2">
                                <Skeleton className="h-4 w-12" />
                                <Skeleton className="h-3 w-16" />
                            </div>
                        ))}
                    </div>
                    
                    {/* Horizontal Divider */}
                    <div className="border-t border-border" />
                    
                    <div className="grid grid-cols-3 divide-x divide-border">
                        {/* Row 2 */}
                        {[...Array(3)].map((_, i) => (
                            <div key={`row2-${i}`} className="h-11 flex flex-col items-center justify-center gap-1 px-2.5 py-2">
                                <Skeleton className="h-4 w-12" />
                                <Skeleton className="h-3 w-16" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Card>
    );
};

